// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { linkListStyles } from "@insite/content-library/Widgets/Basic/SocialLinks";
import { css } from "styled-components";

linkListStyles.socialLinkListWrapper = {
    ...mergeWithCss(linkListStyles.socialLinkListWrapper, {
        css: css`
            justify-content: space-between;
            max-width: 225px;
            margin-left: auto;
            column-gap: 16px;
            row-gap: 8px;
            ${xScreen("lte", 1145)} {
                column-gap: 8px;
            }
            ${xScreen("lte", "md")} {
                column-gap: 16px;
                margin: auto;
            }
        `,
    }),
};

linkListStyles.linkWrapper = {
    css: css`
        height: 44px;
    `,
};
